import { ReactNode, useCallback } from 'react';

import SuccessIcon from '@/assets/icons/done.svg?react';
import ErrorIcon from '@/assets/icons/error.svg?react';
import WarningIcon from '@/assets/icons/warning.svg?react';

import styles from './styles.module.scss';

interface ToastProps {
  title: ReactNode;
  message?: ReactNode;
  type: 'success' | 'error' | 'warning';
}

export function ToastNotification({ title, message, type }: ToastProps) {
  const getIcon = useCallback((type: ToastProps['type']) => {
    switch (type) {
      case 'success':
        return <SuccessIcon />;
      case 'error':
        return <ErrorIcon />;
      case 'warning':
        return <WarningIcon />;
    }
  }, []);

  return (
    <div className={`${styles.toastContainer} ${styles[type]}`}>
      <div className={`${styles.icon} ${styles[`icon__${type}`]}`}>
        {getIcon(type)}
      </div>

      <div>
        <p className={styles.title}>{title}</p>
        {message && <p className={styles.message}>{message}</p>}
      </div>
    </div>
  );
}
